import { render, staticRenderFns } from "./betfinder.vue?vue&type=template&id=5d3bc54c&scoped=true"
import script from "./betfinder.vue?vue&type=script&lang=js"
export * from "./betfinder.vue?vue&type=script&lang=js"
import style0 from "./betfinder.vue?vue&type=style&index=0&id=5d3bc54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3bc54c",
  null
  
)

export default component.exports